import { DropDownType } from "../models/MemberDetails";

export enum LanguageMasterActionDispatchTypes {
    LANGUAGE_MASTER_INVOKE = "LANGUAGE_MASTER_INVOKE",
    LANGUAGE_MASTER_SUCCESS = "LANGUAGE_MASTER_SUCCESS",
  }

  export enum RelationshipActionDispatchTypes {
    RELATIONSHIP_INVOKE = "RELATIONSHIP_INVOKE",
    RELATIONSHIP_SUCCESS = "RELATIONSHIP_SUCCESS",
  }

  export const GENDER_DROPDOWN_OPTIONS: DropDownType[] = [
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    },
    {
      label: "Unknown",
      value: "Unknown",
    },
  ];
  
export const IS_BCBS_MI_AUTH: DropDownType[] = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
]

export enum PayerIdInfo {
  BCBS_MICHIGAN_PAYERID = "00710",
}

export enum BlueCardRequest{
  IS_BLUE_CARD_REQUEST= "Yes"
}

export enum EligibilityType{
  ELIGIBILITY_CHECK= "CHECK",
  PROCEED_TO_REQUEST= "PROCEED"
}